import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { DataTestType } from '@y42/data-test';
import { isNullish } from '@y42/util/nullish';
import { map, Observable } from 'rxjs';
import { DATA_TEST_TYPE_NAMES_TO_UI } from '../../state';

@UntilDestroy()
@Component({
  selector: 'y42-data-test-type-with-icon',
  templateUrl: './data-test-type-with-icon.component.html',
  styleUrls: ['./data-test-type-with-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTestTypeWithIconComponent {
  @Input()
  @InputObservable()
  dataTestType: DataTestType | null = null;
  dataTestType$!: Observable<DataTestType | null | undefined>;

  readonly state = connectState(this, {
    icon: this.dataTestType$.pipe(
      map((dataTestType) =>
        isNullish(dataTestType) ? null : (DATA_TEST_TYPE_NAMES_TO_UI[dataTestType].faIcon as IconName) ?? null,
      ),
    ),
    label: this.dataTestType$.pipe(
      map((dataTestType) => (isNullish(dataTestType) ? null : DATA_TEST_TYPE_NAMES_TO_UI[dataTestType]?.label ?? null)),
    ),
  });
}
